/*  This file can be replicated for the majority of CRUD logic for each model. */

import HTTP from "../../system/utils/Http";
import { notify } from "reapop";
import {
  fetchAllStart,
  fetchAllSuccess,
  fetchAllError,
  fetchStart,
  fetchSuccess,
  fetchError,
  updateStart,
  updateSuccess,
  updateError,
  deleteStart,
  deleteSuccess,
  deleteError,
  createStart,
  createSuccess,
  createError,
} from "./actions";

/* Assign the endpoint URL here */
const endpoint = "/sub-categories/";

export const actionCreators = {
  fetchAll() {
    return (dispatch) => {
      dispatch(fetchAllStart());
      HTTP.get(endpoint)
        .then((res) => {
          dispatch(fetchAllSuccess(res.data.data));
        })
        .catch((err) => {
          dispatch(
            fetchAllError(
              err.response.data.message !== null &&
                err.response.data.message !== undefined
                ? err.response.data.message
                : err.response.data.error.message
            )
          );
          dispatch(
            notify({
              message:
                err.response.data.message !== null &&
                err.response.data.message !== undefined
                  ? err.response.data.message
                  : err.response.data.error.message,
              status: "error",
            })
          );
        });
    };
  },

  fetch(id) {
    return (dispatch) => {
      dispatch(fetchStart());
      HTTP.get(endpoint + id)
        .then((res) => {
          dispatch(fetchSuccess(res.data.data));
        })
        .catch((err) => {
          dispatch(
            fetchError(
              err.response.data.message !== null &&
                err.response.data.message !== undefined
                ? err.response.data.message
                : err.response.data.error.message
            )
          );
          dispatch(
            notify({
              message:
                err.response.data.message !== null &&
                err.response.data.message !== undefined
                  ? err.response.data.message
                  : err.response.data.error.message,
              status: "error",
            })
          );
        });
    };
  },

  create(data) {
    return (dispatch) => {
      HTTP.post(endpoint, data)
        .then((res) => {
          dispatch(createSuccess());
          dispatch(
            notify({ message: "Entry created successfully", status: "success" })
          );
        })
        .catch((err) => {
          dispatch(
            createError(
              err.response.data.message !== null &&
                err.response.data.message !== undefined
                ? err.response.data.message
                : err.response.data.error.message
            )
          );
          dispatch(
            notify({
              message:
                err.response.data.message !== null &&
                err.response.data.message !== undefined
                  ? err.response.data.message
                  : err.response.data.error.message,
              status: "error",
            })
          );
        });
    };
  },

  update(id, data) {
    return (dispatch) => {
      HTTP.put(endpoint + id, data)
        .then((res) => {
          dispatch(updateSuccess(data));
          dispatch(
            notify({ message: "Entry saved successfully", status: "success" })
          );
        })
        .catch((err) => {
          dispatch(
            updateError(
              err.response.data.message !== null &&
                err.response.data.message !== undefined
                ? err.response.data.message
                : err.response.data.error.message
            )
          );
          dispatch(
            notify({
              message:
                err.response.data.message !== null &&
                err.response.data.message !== undefined
                  ? err.response.data.message
                  : err.response.data.error.message,
              status: "error",
            })
          );
        });
    };
  },

  delete(entries) {
    return (dispatch) => {
      dispatch(deleteStart());
      HTTP({ method: "delete", url: endpoint, data: { id: entries } })
        .then((res) => {
          window.location.href = "/sub-categories";
          dispatch(deleteSuccess());
          dispatch(
            notify({
              message: "Entry(s) deleted successfully",
              status: "success",
            })
          );
        })
        .catch((err) => {
          dispatch(
            deleteError(
              err.response.data.message !== null &&
                err.response.data.message !== undefined
                ? err.response.data.message
                : err.response.data.error.message
            )
          );
          dispatch(
            notify({
              message:
                err.response.data.message !== null &&
                err.response.data.message !== undefined
                  ? err.response.data.message
                  : err.response.data.error.message,
              status: "error",
            })
          );
        });
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/SubCategories/index.js